import uuidv4 from 'uuid/v4'
import marked from 'marked'

export function tuid() {
  return Date.now().toString().concat(uuidv4().substring(0, 8))
}

export function pluralize(s, c) {
  if (typeof(s)==='string') {
    if (c===1) {
      return s
    }
    return `${s}s`
  }
  return ''
}

export function timeAgo(d){
  if (typeof(d)==='number') {
    const diff = (new Date() - d)/1000;
    if(diff<60){
      const v = Math.round(diff)
      return `${v} ${pluralize('second',v)} ago`
    }
    else if(diff<60*60){
      const v = Math.round(diff/60)
      return `${v} ${pluralize('minute',v)} ago`
    }
    else if(diff<60*60*24){
      const v = Math.round(diff/(60*60))
      return `${v} ${pluralize('hour',v)} ago`
    }
    else if(diff<60*60*24*30.436875){
      const v = Math.round(diff/(60*60*24))
      return `${v} ${pluralize('day',v)} ago`
    }
    else if(diff<60*60*24*30.436875*12){
      const v = Math.round(diff/(60*60*24*30.436875))
      return `${v} ${pluralize('month',v)} ago`
    }
    const v = Math.round(diff/(60*60*24*30.436875*12))
    return `${v} ${pluralize('year',v)} ago`
  }
  return ''
}

export function slugify(v) {
  if (typeof(v)==='string'&&v.length>0) {
    return v.toString().toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w-]+/g, '') // Remove all non-word chars
      .replace(/--+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, '') // Trim - from end of text
  }
  return ''
}

export function calcSize(text) {
  return text.length+text.length-text.replace(/[\u0100-\uFFFF]/g, '').length+Math.max(0,text.length-text.replace(/(\r?\n|\r)/g, '').length-1)
}

export function partition(list,size=10) {
  const lists = []
  for(let i=0;i<list.length;i+=size) {
    lists.push(list.slice(i,i+size))
  }
  return lists
}

export function lipsum(n=10) {
  if (typeof(n)!=='number') {
    n=10
  } else if (n<0) {
    n=10
  }
  const words = ['lorem', 'ipsum', 'dolor', 'sit', 'amet', 'consectetur', 'adipiscing', 'elit', 'vivamus', 'et', 'accumsan', 'augue', 'duis', 'eget', 'nunc', 'id', 'sodales', 'finibus', 'vestibulum', 'sagittis', 'magna', 'nec', 'rutrum', 'volutpat', 'risus', 'tincidunt', 'justo', 'non', 'gravida', 'tortor', 'enim', 'in', 'urna', 'ut', 'vel', 'metus', 'pellentesque', 'porttitor', 'vitae', 'nisi', 'nullam', 'faucibus', 'condimentum', 'quam', 'imperdiet', 'class', 'aptent', 'taciti', 'sociosqu', 'ad', 'litora', 'torquent', 'per', 'conubia', 'nostra', 'inceptos', 'himenaeos', 'interdum', 'malesuada', 'fames', 'ac', 'ante', 'primis', 'curabitur', 'nibh', 'quis', 'iaculis', 'cras', 'mollis', 'eu', 'congue', 'leo']
  const count = Math.floor(Math.random() * n + 1)
  const sentence = []
  const indexes = (new Array(count)).fill(0).map(index=>{
    return Math.floor(Math.random()*words.length)
  })
  indexes.forEach((index,i)=>{
    const word = words[index]
    if (i===0)
      sentence.push(word.charAt(0).toUpperCase()+word.substr(1))
    else
      sentence.push(word)
  })
  return sentence.join(' ').concat('.')
}

export function isValidName(value) {
  if (typeof(value)==='string'&&value.length>0) {
    return /^[a-z0-9_.@()-]+$/i.test(value)
  }
  return false
}

export function countLines(s) {
  if (typeof(s)==='string'&&s.length>0) {
    return s.split(/\r\n|\r|\n/).length
  }
  return 0
}

export function isNumber(n) {
  return typeof(n)==='number'
}

export function max(a,b) {
  if (isNumber(a)) {
    if (isNumber(b)) {
      if (a>b) return a
      else return b
    } else {
      return a
    }
  } else if (isNumber(b)) {
    return b
  }
  return 0
}

export function fromMd(v) {
  if (typeof(v)==='string') {
    marked.setOptions({
      gfm: true,
    })
    return {__html:marked(v)}
  }
  return {__html:''}
}

// eg: tmplsify('hi, ${name}!')({name:'john'})
/*export const fromTemplate = (s)=>{
  return (data) => new Function(`{${Object.keys(data).join(',')}}`, 'return `' + s + '`')(data)
}*/

export const randInt=(n=10,m=0)=>{
  return Math.floor(Math.random()*n)+m
}

export const randColor=()=>{
  const rgb = (new Array(3)).fill(0).map(e=>randInt(256))
  return '#'.concat(rgb.map(e=>{
    const hex = e.toString(16)
    if (hex.length===1) {
      return `0${hex}`
    }
    return hex
  }).join(''))
}
